import actionTypes from './actionTypes';

export const fetch = (sid, iid) => ({
  type: actionTypes.FETCH,
  payload: {
    sid,
    iid,
  },
});

export const fetching = () => ({
  type: actionTypes.FETCHING,
});

export const fetched = shipment => ({
  type: actionTypes.FETCHED,
  payload: {
    shipment,
  },
});

export const updateDistance = distance => ({
  type: actionTypes.UPDATE_DISTANCE,
  payload: {
    distance,
  },
});

export const updateDuration = duration => ({
  type: actionTypes.UPDATE_DURATION,
  payload: {
    duration,
  },
});

export const fetchQuoteShipments = (qId, shipmentsIds) => ({
  type: actionTypes.FETCH_QUOTE_SHIPMENTS,
  payload: {
    qId,
    shipmentsIds,
  },
});

export const fetchingQuoteShipments = () => ({
  type: actionTypes.FETCHING_QUOTE_SHIPMENTS,
});

export const fetchedQuoteShipments = shipments => ({
  type: actionTypes.FETCHED_QUOTE_SHIPMENTS,
  payload: {
    shipments,
  },
});
